import React from "react";
import './style.css';

export default function SideLink(props) {
  const headers = props.lists.map((val) => {
    return val.id;
  });

  

  return (
    
      <ul class="collection side_nav">
      {props.lists.map((val) => {
        return (
            <a   href={"#section-" + val.id} key={val.id}><li style={{backgroundColor:'#'+props.custom_design.colors[9].color,color:'#'+props.custom_design.colors[10].color}} className="collection-item">
            {val.title}
          </li></a>
        );
      })}
      </ul>
    
  );
}
